import { Document } from "@/types";
import { IDataProvider } from "@/store";

export interface IDocumentState {
  document: Document | null;
  documents: Document[] | null;
  file: Blob | null;
  dataProvider: IDataProvider<Document> | null;
}

export const state: IDocumentState = {
  document: null,
  documents: null,
  dataProvider: {
    items: [],
    pager: {
      buttonsToShow: 3,
      currentPage: 1,
      endPage: 1,
      startPage: 1,
      totalPages: 1,
    },
  },
  file: null,
};

export enum DocumentStatusesEnum {
  NEW = "NEW",
  PROCESS = "PROCESS",
  REWORK = "REWORK",
  SUCCESS = "SUCCESS",
  DENIED = "DENIED",
  DELETED = "DELETED",
}

export const documentStatuses = {
  [DocumentStatusesEnum.NEW]: "Новый",
  [DocumentStatusesEnum.PROCESS]: "В процессе",
  [DocumentStatusesEnum.REWORK]: "На доработке",
  [DocumentStatusesEnum.SUCCESS]: "Выполнен",
  [DocumentStatusesEnum.DENIED]: "Отказан",
  [DocumentStatusesEnum.DELETED]: "Удален",
};

export const documentStatusesForFilter = {
  [DocumentStatusesEnum.NEW]: "?????",
  [DocumentStatusesEnum.PROCESS]: "? ????????",
  [DocumentStatusesEnum.SUCCESS]: "????????",
  [DocumentStatusesEnum.DENIED]: "???????",
};

export enum ProcessUserStatusesEnum {
  ACTIVE = "ACTIVE",
  WAIT = "WAIT",
  SUCCESS = "SUCCESS",
  DENIED = "DENIED",
  CANCELLED = "CANCELLED",
}
export const processUserStatuses = {
  [ProcessUserStatusesEnum.ACTIVE]: "Активный",
  [ProcessUserStatusesEnum.WAIT]: "В ожиданий",
  [ProcessUserStatusesEnum.SUCCESS]: "Выполнен",
  [ProcessUserStatusesEnum.DENIED]: "Отказан",
  [ProcessUserStatusesEnum.CANCELLED]: "Отменён",
};
